/*
 * @Description: 用户管理stroe
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-24 09:14:44
 * @LastEditTime: 2020-11-18 15:03:42
 * @LastEditors:   YOYO [792611446@qq.com]
 */
import userManagement from './userManagement/store'
import loginLog from './loginLog/store'
import DepartmentManagement from './DepartmentManagement/store'
// import Feedback from './Feedback/store'

export const systemManagementStore = {
  userManagement,
  loginLog,
  DepartmentManagement,
  // Feedback,
}

export default systemManagementStore
